import * as ActionTypes from '../constants/ActionTypes'
import { getRequest, postRequest_ } from './http'
import { baseurl } from '../constants/constants';
import { refresh } from 'ionicons/icons';
import { getShoppingCart } from '../utils/functions';

export function setData(items, name) {
    return {
        type: ActionTypes.SET_DATA,
        name: name,
        items: items
    }
}

export function setDataConcat(items, name) {
    return {
        type: ActionTypes.DATA_WITH_PAGINATION_CONCAT,
        name: name,
        items: items
    }
}

const get_ = (data, controller) => {
    return (dispatch) => {
        dispatch(setData({
            loading: { Msg: 'Cargando...', isOpen: true },
            refresh_list: false,
            concat_list: false,
            view_active: data.view_active
        }));
        getRequest(data, controller).then(
            (response) => {

                if (data.typeOption == "get_list_categoria_gastos") {
                    if (data.pages == 0) {
                        dispatch(setData({
                            categorie_expensesDB: response.data,
                            data_pagin_categorie_expensesDB: response.data.data,
                            refresh_list: false,
                            categories_expenses_list: false,
                            loading: { Msg: 'Cargando...', isOpen: false },
                        }));
                    } else {
                        dispatch(setData({
                            categorie_expensesDB: response.data,
                            refresh_list: false,
                            categories_expenses_list: true,
                            loading: { Msg: 'Cargando...', isOpen: false },
                        }));
                        dispatch(setDataConcat(response.data.data, 'data_pagin_categorie_expensesDB'));
                    }
                } else if (data.typeOption == "get_list_gastos") {
                    if (data.pages == 0) {
                        dispatch(setData({
                            expensesDB: response.data,
                            data_pagin_expensesDB: response.data.data,
                            refresh_list: false,
                            expenses_list: false,
                            loading: { Msg: 'Cargando...', isOpen: false },
                        }));
                    } else {
                        dispatch(setData({
                            expensesDB: response.data,
                            refresh_list: false,
                            expenses_list: true,
                            loading: { Msg: 'Cargando...', isOpen: false },
                        }));
                        dispatch(setDataConcat(response.data.data, 'data_pagin_expensesDB'));
                    }
                }
            },
            (err) => {
                dispatch(setData({
                    loading: { Msg: 'Ocurrio un error...', isOpen: false },
                }));
            }
        );
    }
};

const post_ = (data, controller) => {
    return (dispatch) => {
        dispatch(setData({
            loading: { Msg: 'Cargando...', isOpen: true },
            refresh_list: false,
            concat_list: false,
            view_active: data.view_active
        }));

        postRequest_(data, controller).then(
            (response) => {

                if (data.typeOption == "saveDataCategorieExpense") {

                    let data_default = response.data.data_default ? response.data.data_default : {};
                    let categoories = response.data.data_default.categories ? response.data.data_default.categories : [];
                    let subcategories = [];
                    categoories.forEach((category) => {
                        if (category.sub_categories) {
                            subcategories.push(...category.sub_categories);
                        }
                    });
                    data_default['subcategories'] = subcategories;
                    let units = response.data.data_default.units_array ? response.data.data_default.units_array : [];
                    data_default['subcategories'] = subcategories;
                    data_default['units'] = units;
                    let brands = response.data.data_default.brands ? response.data.data_default.brands : [];
                    data_default['brands'] = brands;

                    dispatch(setData({
                        response: { Msg: response.data.msg, success: response.data.success },
                        simpleToast: true,

                        loading: { Msg: 'Cargando...', isOpen: false },
                        refresh_list: true,
                        data_default: data_default
                    }))
                } else if (data.typeOption == "updateDataCategorieExpense") {

                    let data_default = response.data.data_default ? response.data.data_default : {};
                    let categoories = response.data.data_default.categories ? response.data.data_default.categories : [];
                    let subcategories = [];
                    categoories.forEach((category) => {
                        if (category.sub_categories) {
                            subcategories.push(...category.sub_categories);
                        }
                    });
                    data_default['subcategories'] = subcategories;
                    let units = response.data.data_default.units_array ? response.data.data_default.units_array : [];
                    data_default['subcategories'] = subcategories;
                    data_default['units'] = units;
                    let brands = response.data.data_default.brands ? response.data.data_default.brands : [];
                    data_default['brands'] = brands;
                    dispatch(setData({
                        response: { Msg: response.data.msg, success: response.data.success },
                        simpleToast: true,
                        loading: { Msg: 'Cargando...', isOpen: false },
                        refresh_list: true,
                        data_default: data_default
                    }))
                } else if (data.typeOption == "destroyDatacategorieExpense") {
                    let data_default = response.data.data_default ? response.data.data_default : {};
                    let categoories = response.data.data_default.categories ? response.data.data_default.categories : [];
                    let subcategories = [];
                    categoories.forEach((category) => {
                        if (category.sub_categories) {
                            subcategories.push(...category.sub_categories);
                        }
                    });
                    data_default['subcategories'] = subcategories;
                    let units = response.data.data_default.units_array ? response.data.data_default.units_array : [];
                    data_default['subcategories'] = subcategories;
                    data_default['units'] = units;
                    let brands = response.data.data_default.brands ? response.data.data_default.brands : [];
                    data_default['brands'] = brands;
                    dispatch(setData({
                        response: { Msg: response.data.msg, success: response.data.success },
                        simpleToast: true,

                        loading: { Msg: 'Cargando...', isOpen: false },
                        refresh_list: true,
                        data_default: data_default
                    }))
                } else if (data.typeOption == "saveDataExpense") {

                    dispatch(setData({
                        response: { Msg: response.data.msg, success: response.data.success },
                        simpleToast: true,
                        loading: { Msg: 'Cargando...', isOpen: false },
                        refresh_list: true
                    }))
                } else if (data.typeOption == "updateDataExpense") {

                    dispatch(setData({
                        response: { Msg: response.data.msg, success: response.data.success },
                        simpleToast: true,
                        loading: { Msg: 'Cargando...', isOpen: false },
                        refresh_list: true
                    }))
                } else if (data.typeOption == "destroyDataexpense") {

                    dispatch(setData({
                        response: { Msg: response.data.msg, success: response.data.success },
                        simpleToast: true,
                        loading: { Msg: 'Cargando...', isOpen: false },
                        refresh_list: true
                    }))
                }


            },
            (err) => {
                dispatch(setData({
                    loading: { Msg: 'Ocurrio un error...', isOpen: false },
                }));
            }
        );
    }
};

export default {
    get_,
    post_,
    setData
}